import { VenereAvatar, VenereGLP1Box, VenereMotivationalBox } from '@/features/venere';
import { useUserStore } from '@/utils/stores/useUserStore';
import React from 'react';
import VenerePlatformLayout from '../../shared/pages/VenerePlatformLayout';
import VenereProgressBox from '../components/VenereProgressBox';
import VenereQuickActions from '../components/VenereQuickActions';

export const VenereHome: React.FC = () => {

  const { name } = useUserStore().userData

  // useScrollToTop()

  // Sample data for the match box
  const matchBoxData = {
    bloodStatus: {
      icon: '🩸',
      status: 'Livello ottimale',
      comment: 'I tuoi valori sono nella norma'
    },
    medication: {
      name: 'Metformina',
      dosage: '500mg - 2 volte al giorno'
    },
    mood: {
      current: 'Tranquillo',
      emoji: '😌',
      note: 'Oggi mi sento più rilassato'
    },
    hints: [
      'Bevi almeno 2 litri d\'acqua al giorno',
      'Fai una passeggiata di 30 minuti',
      'Controlla la glicemia prima dei pasti',
      'Mantieni un diario alimentare'
    ]
  };

  return (
    <VenerePlatformLayout>
      <div className="p-4 md:p-8 flex flex-col gap-6">
        <div className='flex flex-col items-center gap-4'>
          <div className='venere-text-heading text-center'>
            Ciao {name}!
          </div>
          <div className='venere-text-subheading text-center'>
            Facciamo un piccolo check insieme.
          </div>
          <VenereAvatar
            variant="welcome"
            size="xl"
          />
        </div>
        
        {/* Responsive Boxes Container */}
        <div className="flex flex-col lg:flex-row gap-6 w-full lg:justify-between">
          {/* GLP1 Box - Flexible width with max-width */}
          <div className="flex-1 min-w-0 lg:max-w-[800px]">
            <VenereGLP1Box />
          </div>
          
          {/* Motivational Box - Flexible width when GLP1 reaches max */}
          <div className="w-full lg:w-80 lg:flex-1 lg:max-w-[600px] lg:flex-shrink-0">
            <VenereMotivationalBox />
          </div>
        </div>
        <VenereQuickActions/>
        <VenereProgressBox/>
      </div>
    </VenerePlatformLayout>
  );
};

export default VenereHome; 